if(!customElements.get('collection-filters') && !customElements.get('collection-filters-tags')) {
  class CollectionFiltersAbstract extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.form = this.querySelector('form');
      this.summary = this.querySelector('.summary');
      this.ajax = true;

      if (this.form) {
        this.form.addEventListener('submit', (e)=>{
          e.preventDefault();
        });
      }
    }
  }

  if(!customElements.get('collection-filters')) {
    class CollectionFilters extends CollectionFiltersAbstract {
      constructor() {
        super();
/*
        if ($s.media.isMediumDown) {
            const collectionGrid = document.querySelector('.collection-grid');
            collectionGrid.setAttribute('data-columns', '2');
        }
        */

        document.querySelector('.filters-trigger.medium-down--hide').addEventListener('click', this.handleFiltersTriggerClick.bind(this));
        document.querySelector('.filters-trigger.medium-down--flex').addEventListener('click', this.handleFiltersTriggerClickMobile.bind(this, 'open'));
        document.querySelector('.close-filters').addEventListener('click', this.handleFiltersTriggerClickMobile.bind(this, 'close'));

        document.querySelectorAll('.collection-filters .group button').forEach((item) => item.addEventListener('click', this.expandCollapseFiltersItems.bind(this)))

        this.populateFilterColors();

        this.querySelectorAll('input').forEach((option)=>{
          option.addEventListener('change', (e)=>{
            this.filterResults();
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.optionId=='filter-price') {
                this.querySelector('#filter-price-min').value = '';
                this.querySelector('#filter-price-max').value = '';
              } else {
                if(button.dataset.clearAll) {
                  this.querySelectorAll('.group input').forEach((element)=>{
                    element.value = '';
                    element.checked = false;
                  });
                } else {
                  this.querySelector('#'+button.dataset.optionId).checked = false;
                }
              }
              this.filterResults();
            });
          });
        }
      }

      getSearchParams() {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);

        var params = new URLSearchParams();
        const keys = Array.from(searchParams.keys()).filter((x, i, a) => a.indexOf(x)==i);
        keys.forEach((key)=>{
          let values = searchParams.getAll(key);
          if(values.find(x=>x!="")) {
            params.set(key, values.join(','));
          }
        });

        var currenSearch = new URLSearchParams(location.search);
        if(currenSearch.has('sort_by')) {
          params.set('sort_by', currenSearch.get('sort_by'));
        }

        return params;
      }

      filterResults() {
        var url;
        var params = this.getSearchParams();
        var paramsString = params.toString().replace(/%2C/g, ',');
        if(this.ajax) {
          $s.showLoadingOverlay();
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          var isOpen = this.isOpen();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          }, true, (doc)=> {
            if (isOpen) {
              doc.querySelector('.collection-filters').dataset.open = true;
            }
          });
        } else {
          url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          location = url;
        }
      }

      populateFilterColors() {
        document.querySelectorAll('.group.color .item').forEach(function(item) {
            const hexColor = item.querySelector('input').getAttribute('value');
            item.querySelector('.color-swatch').style.backgroundColor = '#' + hexColor;
        })
      }

      expandCollapseFiltersItems(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const group = e.target.closest('.group');
            const list = group.querySelector('.list');
            const icon = group.querySelector('.icon');

            if (list.getAttribute('aria-expanded') == 'false') {
                list.setAttribute('aria-expanded', 'true');

                if (!$s.isVisible(list)) {
                    icon.style.transform = 'rotate(180deg)';
                    $s.expand([list])
                }
            } else {
                list.setAttribute('aria-expanded', 'false');
                if ($s.isVisible(list)) {
                    icon.style.transform = 'rotate(0deg)';
                    $s.collapse([list])
                }
            }
      }

      handleFiltersTriggerClick() {
        const trigger = document.querySelector('.collection-top .filters-trigger .trigger-title');
        const collectionGrid = document.querySelector('.collection-grid');
        if (this.getAttribute('aria-expanded') == 'false') {
            this.setAttribute('aria-expanded', 'true');

            if (!$s.isVisible(this)) {
                this.style.width = '20%';
                this.style.visibility = 'visible';
                this.style.display = 'block';
                trigger.innerHTML = 'Hide Filters';
                collectionGrid.setAttribute('data-filters-opened', 'true');
            }
        } else {
            this.setAttribute('aria-expanded', 'false');
            if ($s.isVisible(this)) {
                this.style.width = '0';
                this.style.visibility = 'hidden';
                this.style.display = 'none';
                trigger.innerHTML = 'Show Filters';
                collectionGrid.setAttribute('data-filters-opened', 'false');
            }
        }
      }

      handleFiltersTriggerClickMobile(behavior) {
        const trigger = document.querySelector('.collection-top .filters-trigger .trigger-title');
        const collectionGrid = document.querySelector('.collection-grid');
        const body = document.querySelector('body');

        if (behavior == 'open') {
            this.setAttribute('aria-expanded', 'true');
            if ($s.isVisible(this)) {
                this.style.width = '100%';
                this.style.visibility = 'visible';
                this.style.display = 'block';
                trigger.innerHTML = 'Filter & Sort';
                collectionGrid.setAttribute('data-filters-opened', 'true');
                body.style.overflow = 'hidden';
                body.style.height = '100%';
            }
        } else {
            this.setAttribute('aria-expanded', 'false');
            if ($s.isVisible(this)) {
                this.style.width = '0';
                this.style.visibility = 'hidden';
                this.style.display = 'none';
                trigger.innerHTML = 'Filter & Sort';
                collectionGrid.setAttribute('data-filters-opened', 'false');
                body.style.overflow = 'auto';
                body.style.height = 'auto';
            }
        }
      }
    }
    customElements.define('collection-filters', CollectionFilters);
  }

  if(!customElements.get('collection-filters-tags')) {
    class CollectionFiltersTags extends CollectionFiltersAbstract {
      constructor() {
        super();
        this.baseUrl = location.origin + this.dataset.baseUrl;

        this.querySelectorAll('.item a').forEach((link)=>{
          link.addEventListener('click', (e)=>{
            e.preventDefault();
            this.filterResults(link.href);
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.clearAll) {
                var url = new URL(this.baseUrl);
                var currentUrl = new URL(location.href);
                url.search = currentUrl.search;
                this.filterResults(url.toString());
              } else {
                this.querySelector('#'+button.dataset.optionId).closest('a').dispatchEvent(new Event('click', {bubbles: true}));
              }
            });
          });
        }
      }

      filterResults(url) {
        if(this.ajax) {
          $s.showLoadingOverlay();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          });
        } else {
          location = url;
        }
      }
    }
    customElements.define('collection-filters-tags', CollectionFiltersTags);
  }
}

if(!customElements.get('collection-sort')) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.dropdown = this.querySelector('#sort-by');
      this.ajax = true;

      var search = new URLSearchParams(location.search)
      this.dropdown.value = search.get('sort_by') || this.dataset.sortBy;

      this.dropdown.addEventListener('change', ()=>{
        var search = new URLSearchParams(location.search); //get new instance
        search.set('sort_by', this.dropdown.value);
        search.delete('page');
        var paramsString = search.toString();

        if(this.ajax) {
          $s.showLoadingOverlay();
          const url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          });
        } else {
          location.search = paramsString;
        }
      });
    }
  }
  customElements.define('collection-sort', CollectionSort);
}

if(!customElements.get('hotspot-item')) {
  class HotspotItem extends HTMLElement {
    constructor() {
      super();
      this.capsulesButtons = this.querySelectorAll('div.spot');
      this.shopCapsuleButton = this.querySelector('.shop-capsule');
      this.capsulePopup = this.querySelector('.capsule-popup');

      this.capsulesButtons.forEach((item) => {
          const productData = JSON.parse(item.dataset.product);
          item.addEventListener('click', this.openCapsule.bind(this));
        })

        document.addEventListener('click', (event) => {
          if(!this.capsulePopup || (!event.target.closest('.capsule-popup') && event.target.id!="loading-overlay" && this.capsulePopup.classList.contains('open'))) {
            this.closeCapsule();
          }
      });

      this.shopCapsuleButton.addEventListener('click', this.openCapsule.bind(this));
    }

    addToCartAllProducts(){
        var variantIds = [];
        this.closeCapsule();
        this.capsulePopup.querySelectorAll('add-to-cart-form-capsule').forEach((el) => {
          variantIds.push(el.querySelector('[name="id"]').value);
        });

        if(variantIds.length <= 0) return false;

        $s.post({
          url: '/cart/add.js',
          data: {items:variantIds.map((variantId) =>{ return {id:variantId, quantity:1} })},
          success: ()=>{
            this.qtyChecker = window.document.querySelectorAll(".qty-checker");
            this.qtyChecker.forEach((quantitychecker) => {
              let qtynew = parseInt(quantitychecker.innerHTML);
                qtynew++;
                quantitychecker.innerHTML = qtynew;
            });

            window.SideCart.updateSideCart(true);
            this.closeCapsule();
          },
          error: function(response){
            $s.addToCartFail(response.description);
          }
        })
      }

    openCapsule(e){
      if (!e.target.classList.contains('product-card-tooltip')) {
        $s.showOverlay();
        if (e.target.dataset.product) {
          let productJson = '[' + e.target.dataset.product + ']';
          this.capsulePopup.innerHTML = this.buildCapsulePopUpHtml(productJson);
        } else {
          let productsJson = e.target.dataset.products.substring(0, e.target.dataset.products.length - 1);
          productsJson = '[' + productsJson + ']';
          this.capsulePopup.innerHTML = this.buildCapsulePopUpHtml(productsJson);
        }

        this.capsulePopup.querySelector('.close').addEventListener('click', this.closeCapsule.bind(this));
        this.capsulePopup.querySelector('.btn-add-all').addEventListener('click', this.addToCartAllProducts.bind(this));

        setTimeout(()=>{
          this.capsulePopup.classList.add('open');
          setTimeout(() => {
            $s.trapFocus(this.capsulePopup, null);
            setTimeout(() => {
              this.createVariantChangeEvents();
            }, 1000);
          }, 50);
        }, 100);
      }
    }

      closeCapsule(){
        $s.hideOverlay();
        this.capsulePopup.classList.remove('open');
        $s.removeTrapFocus();
      }

      createVariantChangeEvents () {
        var productCards = document.querySelectorAll('.capsule-popup .item.product-main-element.atc')
        var ATCButton = document.querySelector('.capsule-popup .btn.btn-add-all')
        for (var card of productCards) {
          const targetNode = card.querySelector('input[name=id]');
          const config = { attributes: true, childList: false, subtree: false };

          const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
              if (mutation.type === "attributes") {
                let disabled = false
                for(var localCard of productCards) {
                  var cardId = localCard.dataset.productId
                  var attr = document.querySelector(`.item-${cardId} button[type=submit]`).getAttribute('disabled')
                  if (attr == 'disabled') disabled = true
                }

                if (disabled == true) {
                  ATCButton.setAttribute('disabled', 'disabled')
                } else {
                  ATCButton.removeAttribute('disabled')
                }
              }
            }
          };

          const observer = new MutationObserver(callback);
          observer.observe(targetNode, config);
        }
      }

      buildCapsulePopUpHtml(productJson){
        var capsuleProducts = JSON.parse(productJson);

        var availableToPurchase = true;
        [...capsuleProducts].map((item) => {
          var defaultVariant = item.variants.find(x=>x.id==item.default_variant || !item.default_variant);
          if(!defaultVariant.available){
            availableToPurchase = false;
          }
        })

        var html = `
        <div class="content flex direction-column">
          <div class="head">
            <h2>${capsuleProducts.length == 1 ? 'Shop the Product' : 'Shop the Look'}</h2>
            <button class="close" aria-label="Close Capsule">
              <svg class="icon icon-close" viewBox="0 0 32 32"><path fill="" d="M17.825,16l10.208,10.207l-1.827,1.826L16,17.824L5.793,28.033l-1.826-1.826L14.174,16L3.967,5.793l1.826-1.826L16,14.174 L26.208,3.967l1.825,1.826L17.825,16z"/></svg>
            </button>
          </div>

          <div class="wrap">
            <div class="capsule-items">

            ${[...capsuleProducts].map((item) => {
                //var prod = JSON.parse(item.dataset.product);
                return this.buildCapsulePopupCardHtml(item);
              }).join('')}
            </div>
          </div>
          <div class="foot">
            ${availableToPurchase == true ? '<button type="button" class="btn btn-add-all">ADD ALL PIECES TO BAG</button>' : '<button type="button" disabled="disabled" class="btn btn-add-all">ADD ALL PIECES TO BAG</button>'}
          </div>
        </div>
        `;

        return html;
      }

      buildCapsulePopupCardHtml(prod){
        var defaultVariant = prod.variants.find(x=>x.id==prod.default_variant || !prod.default_variant);
        var defaultVariantIventory = prod.variants_inventory[defaultVariant.id];
        var productInventoryThreshold = prod.inventory_threshold;
        var inventoryAvailable = defaultVariantIventory.inventory_quantity > productInventoryThreshold;
        
        var html = `
            <product-card-atc data-section="${this.sectionId}-${prod.id}" data-product-id="${prod.id}" class="item item-${prod.id} product-main-element atc" id="main-product-${this.sectionId}">
            <div class="grid">

              <div class="grid-item one-half small--two-fifths image-wrapper">
                <a href="${prod.url}">
                  <img class="img main lazyload" alt="" data-sizes="auto" data-srcset="${this.getImgSrcSet(prod.images[0])}" width="${prod.images[0].width}" height="${prod.images[0].height}" />
                </a>
              </div>

              <div class="grid-item one-half small--three-fifths info-wrapper">
                <a href="${prod.url}" class="prod-title">${prod.title}</a>


                <add-to-cart-form-capsule>

                  ${this.buildVariantsInventoryHtml(prod)}

                  <div class="price">
                    <span class="final ${( prod.compare_at_price > prod.price ) ? '' : 'regular-final'}">${ $s.formatMoney(prod.price).replace('.00', '')}</span>
                    <span class="compare ${( prod.compare_at_price > prod.price ) ? '' : 'hide'}">${$s.formatMoney(prod.compare_at_price).replace('.00', '')}</span>
                  </div>
                  <div class="atc-options-wrapper">
                    <div class="atc-options hide">Options</div>
                    <form action="/cart/add" method="post" autocomplete="off">
                      <div class="variant-wrapper">
                        ${
                          (prod.current_color) ?
                          `
                            <div class="variant">
                              <span>Color: </span> ${prod.current_color}
                            </div>
                          ` : ''
                        }
                        <product-variants ` + (prod.variants.length==1 ? `class="visually-hidden"` : ``) + `>`;

                    if (!prod.has_only_default_variant) {
                      var optionsHtml = '';
                      prod.options.forEach((option,ix)=> {
                        if (option=='Color') {
                          optionsHtml += `<product-swatch class="color-swatches" data-option="${ix + 1}" data-label="${option}"></product-swatch>`;
                        } else {
                          optionsHtml += `<product-dropdown data-option="${ix + 1}" data-label="${option}"></product-dropdown>`;
                        }
                      });

                      html += optionsHtml;
                    }


                    html += `
                          <input data-variant-id="true" type="hidden" name="id" value="${defaultVariant.id}" />

                        </product-variants>
                      </div>

                      ${
                        (prod.preorder) ?
                          `<div>
                            <div class="red-note">
                              <span>${prod.preorder}</span>
                            </div>
                          </div>` : ''
                      }

                      ${
                        (prod.final_sale) ?
                          `<div>
                            <div class="red-note flex justify-content-between align-items-center">
                              <span>${prod.final_sale}</span>
                              <div><svg class="icon" viewBox="0 0 32 32"><path fill="" d="M16.00022.00043A16.01538,16.01538,0,1,0,27.30937,4.69121,15.99974,15.99974,0,0,0,16.00022.00043Zm0,29.53839a13.55389,13.55389,0,1,1,9.5685-3.96975,13.53815,13.53815,0,0,1-9.5685,3.96975ZM18.46175,23.385A1.23091,1.23091,0,0,1,17.231,24.61576H16.00022A1.2306,1.2306,0,0,1,14.76946,23.385V16.0004a1.23077,1.23077,0,1,1,0-2.46153h1.23076A1.23093,1.23093,0,0,1,17.231,14.76963v7.3846A1.23091,1.23091,0,0,1,18.46175,23.385ZM13.84638,9.23119a1.84593,1.84593,0,1,1,.54066,1.30549A1.8457,1.8457,0,0,1,13.84638,9.23119Z"/></svg></div>
                            </div>
                          </div>`
                          : ''
                      }

                      <product-buttons>
                        <button type="submit" class="btn add v3" ` + (!defaultVariant.available || !inventoryAvailable ? `disabled="disabled"` : ``) + `>
                          <span class="one-whole btn-text" ` + (!defaultVariant.available || !inventoryAvailable ? `style="display:none;"` : ``) + `>
                            ${(prod.preorder) ? 'PREORDER' : 'ADD'}
                          </span>
                          <span class="sold-out-message" ` + (defaultVariant.available && inventoryAvailable ? `style="display:none;"` : ``) + `>SOLD OUT</span>
                        </button>
                      </product-buttons>
                      <script type="application/json">
                        ${JSON.stringify(prod)}
                      </script>
                    </form>
                  </div>
                </add-to-cart-form-capsule>

              </div>

            </div>
            </product-card-atc>
          `;
          return html;
      }

      buildVariantsInventoryHtml(prod){
        var html = `
          <div class="variant-inventory">
            ${[...prod.variants].map((variant) => {
              var variantIventory = prod.variants_inventory[variant.id];
              return `
                <input type="hidden" name="variant_${variant.id}_inventory_available" value="${variantIventory.inventory_quantity > prod.inventory_threshold}" />
              `;
            }).join('')}
          </div>
        `;

        return html;
      }

      getImgSrcSet(imgData) {
        const sizes = [180,360,540,720,900,1080];
        var ret = [];
        var item;
        for (var i=0; i<sizes.length; i++) {
          if (imgData.width > sizes[i]) {
            item = $s.imgUrlFilter(imgData.src, sizes[i]+'x') + ' ' + sizes[i] + 'w';
            ret.push(item);
          } else {
            item = imgData.src + ' ' + imgData.width + 'w';
            ret.push(item);
            break;
          }
        }

        return ret.join(', ');

      }
  }
  customElements.define('hotspot-item', HotspotItem);
}

if(!customElements.get('add-to-cart-form-capsule')) {
  class AddToCartFormCapsule extends HTMLElement {
    constructor() {
      super();
      this.addToCartBtn = this.querySelector('button.add');
      this.mainElement = this.closest('.product-main-element');
      this.hotspotItem = this.querySelector('hotspot-item');
      this.mainElement.addEventListener('variantChange', (e)=>{
        var variantIventoryAvailable = (e.detail.variant) ? this.querySelector(`input[name="variant_${e.detail.variant.id}_inventory_available"]`).value == 'true' : false;
      	if(e.detail.variant && e.detail.variant.available && variantIventoryAvailable) {
          this.addToCartBtn.style.display = '';
          if(this.mainElement.querySelector('.price')){
            this.mainElement.querySelector('.price').innerHTML = `
              <div class="compare ${( e.detail.variant.compare_at_price > e.detail.variant.price ) ? '' : 'hide'}">${$s.formatMoney(e.detail.variant.compare_at_price)}</div>
            `;
          }
          this.querySelector('.sold-out-message').style.display = 'none';
          this.querySelector('.btn.add.v3').removeAttribute("disabled");
          this.querySelector('.one-whole.btn-text').style.display = 'block';

      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.one-whole.btn-text').style.display = 'none';
          this.querySelector('.btn.add.v3').setAttribute("disabled","disabled");
          this.querySelector('.sold-out-message').style.display = 'block';
      	}
        if(this.hotspotItem.querySelectorAll('.btn.add.v3[disabled="disabled"]').length == 0) {
          this.hotspotItem.querySelector('.btn.btn-add-all').removeAttribute("disabled");
        }else{
          this.hotspotItem.querySelector('.btn.btn-add-all').setAttribute("disabled","disabled");
        }
      });

      this.addToCartBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        var fd = new FormData();
        this.querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>fd.append(x.name, x.value));

        $s.showLoadingOverlay();
        $s.post({
          url: '/cart/add.js',
          data: fd,
          success: ()=>{
            this.qtyChecker = window.document.querySelectorAll(".qty-checker");
            this.qtyChecker.forEach((quantitychecker) => {
              let qtynew = parseInt(quantitychecker.innerHTML);
                qtynew++;
                quantitychecker.innerHTML = qtynew;
            });

            this.addToCartBtn.querySelector('.btn-text').innerHTML = 'ADDED!';
            window.SideCart.updateSideCart();
            $s.hideLoadingOverlay();

          },
          error: function(response){
            $s.addToCartFail(response.description);
          }
        })
      });
    }
  }
  customElements.define('add-to-cart-form-capsule', AddToCartFormCapsule);
  }